var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_634_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 10.5468H16.4062C16.8379 10.5468 17.1875 10.1972 17.1875 9.76553V8.98428C17.1875 8.55264 16.8379 8.20303 16.4062 8.20303H8.59375C8.16211 8.20303 7.8125 8.55264 7.8125 8.98428V9.76553C7.8125 10.1972 8.16211 10.5468 8.59375 10.5468ZM7.8125 14.453C7.8125 14.8847 8.16211 15.2343 8.59375 15.2343H16.4062C16.8379 15.2343 17.1875 14.8847 17.1875 14.453V13.6718C17.1875 13.2401 16.8379 12.8905 16.4062 12.8905H8.59375C8.16211 12.8905 7.8125 13.2401 7.8125 13.6718V14.453ZM12.5 20.3676C11.6982 20.3676 10.8965 20.1205 10.2119 19.6259L0 12.2489V22.6562C0 23.9506 1.04932 24.9999 2.34375 24.9999H22.6562C23.9507 24.9999 25 23.9506 25 22.6562V12.2489L14.7881 19.6259C14.1035 20.12 13.3018 20.3676 12.5 20.3676ZM24.1021 7.95645C23.6699 7.61758 23.2603 7.29873 22.6562 6.84268V4.68741C22.6562 3.39297 21.6069 2.34366 20.3125 2.34366H16.5259C16.3774 2.23623 16.2393 2.13565 16.0845 2.02334C15.2637 1.42422 13.6328 -0.0171833 12.5 -9.34878e-05C11.3672 -0.0171833 9.73682 1.42422 8.91553 2.02334C8.76074 2.13565 8.62256 2.23623 8.47412 2.34366H4.6875C3.39307 2.34366 2.34375 3.39297 2.34375 4.68741V6.84268C1.73975 7.29825 1.33008 7.61758 0.897949 7.95645C0.618241 8.17565 0.392048 8.4556 0.236481 8.77511C0.0809144 9.09462 4.81351e-05 9.44532 0 9.80069L0 10.3207L4.6875 13.7069V4.68741H20.3125V13.7069L25 10.3207V9.80069C25 9.08096 24.6689 8.40079 24.1021 7.95645V7.95645Z",
    fill: "url(#paint0_linear_634_2713)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_634_2713",
    x1: 12.5,
    y1: -0.000244141,
    x2: 12.5,
    y2: 24.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A1D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#156FBC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_634_2713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.3eb2e8a60065ca83fd54b57a471797db.svg";
export { ForwardRef as ReactComponent };